<h1 mat-dialog-title>{{ model.header }}</h1>
<mat-dialog-content class="mat-typography">
  <p>{{ model.message }}</p>
  
  <!-- Input field with mat-error shown when input is empty -->
  <mat-form-field *ngIf="model.acceptDisabled" appearance="outline" class="input-field">
    <input matInput [(ngModel)]="model.inputText" [placeholder]="model.inputPlaceholder || 'Enter text here'">
   
  </mat-form-field>
    <div *ngIf="model.acceptDisabled">
        <mat-error *ngIf="!model.inputText?.trim()">Polje mora biti popunjeno</mat-error>
    </div>
  
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="close()">{{ model.rejectLabel }}</button>
  
  <!-- Accept button, disabled when inputText is empty or only whitespace -->
  <button *ngIf="model.acceptDisabled" mat-raised-button class="default-button-color" 
          [disabled]="!model.inputText?.trim()" (click)="confirm()">
    {{ model.acceptLabel }}
  </button>
</mat-dialog-actions>